module.exports = __webpack_public_path__ + "images/moonshot/fortnite.31860355cc166b2844ea.png";